import { useEffect, useState } from 'react'
import { useAxiosInterceptor } from './axiosInterceptor'
import publicIp from 'react-public-ip'
import { setTranslations, setDefaultLanguage } from 'react-multi-lang'
import Router from './Router'
import { Helmet } from 'react-helmet'
import Nav from './components/Nav/Nav'
import Footer from './components/Footer/Footer'
import fr from './lang/fr.json'
import en from './lang/en.json'
import vn from './lang/vn.json'
import './App.css'
import './styles/colors.css'
import { useLocation } from 'react-router-dom'

setTranslations({ fr, en, vn })
setDefaultLanguage('fr')

function App() {

    useAxiosInterceptor()
    const location = useLocation()
    const [ip, setIp] = useState(null)

    useEffect(() => {

        getIp()

    }, [])

    async function getIp() {

        const ipv4 = await publicIp.v4() || ""
        const ipv6 = await publicIp.v6() || ""
        if (ipv4) {
            setIp(ipv4)
        } else if (ipv6) {
            setIp(ipv6)
        }

    }

    return (

        <div className='app'>

            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="theme-color" content="#ffffff" />
                <meta name="robots" content="index, follow" />
                <meta name="author" content="Bastien Desfrere" />
                <meta property="og:type" content="website" />
            </Helmet>
            {!location.pathname.startsWith('/administration/') ?
                <>
                    <Nav />
                    <Router ip={ip} />
                    <Footer ip={ip} />
                </>
                :
                <Router ip={ip} />
            }

        </div>

    )

}

export default App
